import { computed, inject, watch, ref, triggerRef } from "vue";
import { useInstantSearch } from "./useInstantSearch.mjs";
import { useState } from "nuxt/app";
export const useAisWidget = (widgetName, id) => {
  const { getInstance } = useInstantSearch();
  const instance = getInstance();
  const maybeInjectedIndex = inject("index", void 0);
  const index = maybeInjectedIndex ?? instance.value.indexName;
  const _state = id ? inject(`${widgetName}-${id}`, void 0) : ref(instance.value.renderState[index][widgetName]);
  const state = import.meta.server ? _state : id ? useState(`${widgetName}-${id}`, () => _state) : _state;
  watch(
    instance,
    () => {
      if (!id) {
        state.value = instance.value.renderState[index][widgetName];
      } else {
        triggerRef(state);
      }
    },
    { deep: true }
  );
  if (!state.value)
    throw new Error(
      `Connector for component ${widgetName} not found, did you forget to add the proper widget?`
    );
  const widgetParams = computed(() => state.value.widgetParams);
  return {
    instance,
    state,
    widgetParams
  };
};
